module.exports = __webpack_public_path__ + "img/article10-1.d07e73d7.jpg";